// utils/upgradePopupCopy.ts
//
// What the upgrade popup says for each kind of moment (product UI spec).
// "limit"  -> the Free Companion Talk limit (conversation 12)
// "locked" -> the user opened a Pro-only insight (Current Season, Growth Edge, ...)
// "generic" -> any other allowed trigger: title/subtitle come from the server.
// English only for now; the server's localized copy is the fallback for "generic".
import type { UpgradePopupTrigger } from "./upgradePopup";

export type PopupVariant = "limit" | "locked" | "generic";

export interface PopupVariantCopy {
  title: string;
  /** Lines under the title, in order (the last one is shown quieter). */
  body: string[];
  benefits: string[];
  cta: string;
  dismiss: string;
}

export const LOCKED_TRIGGERS: ReadonlySet<UpgradePopupTrigger> = new Set<UpgradePopupTrigger>([
  "user_opens_locked_content",
  "user_clicks_growth_edge",
  "user_clicks_current_season",
  "user_clicks_full_chart",
  "user_clicks_full_personality",
  "user_clicks_life_blueprint",
]);

export const getPopupVariant = (trigger?: string | null): PopupVariant => {
  if (trigger === "companion_limit_reached") return "limit";
  return LOCKED_TRIGGERS.has(trigger as UpgradePopupTrigger) ? "locked" : "generic";
};

export const VARIANT_COPY: Record<"limit" | "locked", PopupVariantCopy> = {
  limit: {
    title: "Continue Your Journey",
    body: ["You've reached today's free companion limit.", "The next layer is waiting."],
    benefits: [
      "Unlimited conversations",
      "Current Season & Growth Edge",
      "Identity & recurring patterns",
      "Deeper Life GPS insights",
    ],
    cta: "Unlock Astria Pro",
    dismiss: "Maybe Later",
  },
  locked: {
    title: "Available in Pro",
    body: ["This insight lives beneath the surface layer."],
    benefits: ["Current Season", "Growth Edge", "Identity Patterns", "Deeper Meanings"],
    cta: "Unlock Pro",
    dismiss: "Maybe Later",
  },
};
